import Navbar from "@/components/site/Navbar";
import AnnouncementBar from "@/components/site/AnnouncementBar";
import Hero from "@/components/site/Hero";
import WhyChoose from "@/components/site/WhyChoose";
import Services from "@/components/site/Services";
import Availability from "@/components/site/Availability";
import Packages from "@/components/site/Packages";
import Testimonials from "@/components/site/Testimonials";
import AppointmentForm from "@/components/site/AppointmentForm";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import FloatingActions from "@/components/site/FloatingActions";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-[#FAFAFA] text-[#0B2545]">
      <AnnouncementBar />
      <Navbar />
      <main>
        <Hero />
        <WhyChoose />
        <Services />
        <Availability />
        <Packages />
        <Testimonials />
        <AppointmentForm />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
